<script setup>
import { ref, onMounted } from 'vue'
import { scheduleApi } from '@/apis/schedule.api'

const data = ref(null)

onMounted(async () => {
  const res = await scheduleApi.getMissingResourcesSummaryAsync()
  data.value = res.data
})
</script>

<template>
  <div style="padding: 16px; display: flex; flex-direction: column;">
    <div v-if="data === null" style="display:flex; justify-content:center; align-items:center; height:80px;">
      <q-spinner size="md" color="primary" />
    </div>
    <template v-else>
      <div class="text-subtitle1 text-weight-bold q-mb-sm" style="line-height: 1.3;">
        Are there any staff or equipment missing for planned projects?
      </div>
      <div class="text-h3 text-weight-bold" :class="data.count > 0 ? 'text-negative' : 'text-positive'">
        {{ data.count }}
      </div>
      <div class="text-caption text-grey-6 q-mt-xs">Unconfirmed allocations this week</div>
      <div class="text-caption text-grey-5" style="margin-top: 12px;">{{ data.week_label }}</div>
    </template>
  </div>
</template>
